import { useState } from "react";
import { AuthPageLayout } from "./auth-page-layout";
import { GoogleSignInButton } from "./google-sign-in-button";
import { OAuthDivider } from "./oauth-divider";
import {
  Button,
  FormError,
  FormField,
  PasswordInput,
  TextInput,
} from "@/components/ui";

export function RegisterPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");

    if (password1 !== password2) {
      setError("Passwords do not match.");
      return;
    }

    setIsSubmitting(true);
    console.log("[workshop] Register submitted:", { name, email, password1, password2 });

    setTimeout(() => {
      setIsSubmitting(false);
    }, 1500);
  }

  return (
    <AuthPageLayout>
      <div className="flex flex-col gap-6">
        <h2
          className="text-2xl font-semibold text-primary"
          data-testid="register-heading"
        >
          Create your account
        </h2>

        <FormError
          message={error}
          className="mt-0"
          data-testid="register-error"
        />

        <GoogleSignInButton
          label="Sign up with Google"
          data-testid="register-google-button"
        />

        <OAuthDivider />

        <form
          onSubmit={handleSubmit}
          className="flex flex-col gap-5"
          data-testid="register-form"
        >
          <FormField label="Name" htmlFor="name">
            <TextInput
              id="name"
              autoComplete="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Your name"
              className="h-12 rounded-xl text-sm px-4"
              data-testid="register-name"
            />
          </FormField>

          <FormField label="Email address" htmlFor="email">
            <TextInput
              id="email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="h-12 rounded-xl text-sm px-4"
              data-testid="register-email"
            />
          </FormField>

          <FormField label="Password" htmlFor="password1">
            <PasswordInput
              id="password1"
              required
              autoComplete="new-password"
              value={password1}
              onChange={(e) => setPassword1(e.target.value)}
              placeholder="Create a password"
              className="h-12 rounded-xl text-sm"
              data-testid="register-password1"
            />
          </FormField>

          <FormField label="Confirm password" htmlFor="password2">
            <PasswordInput
              id="password2"
              required
              autoComplete="new-password"
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
              placeholder="Confirm your password"
              className="h-12 rounded-xl text-sm"
              data-testid="register-password2"
            />
          </FormField>

          <Button
            type="submit"
            variant="secondary"
            size="lg"
            disabled={isSubmitting}
            className="w-full liquid-glass-distortion shadow-glass border-glass-stroke-light font-semibold text-accent"
            data-testid="register-submit"
          >
            {isSubmitting ? "Creating account..." : "Create account"}
          </Button>
        </form>

        {/* Bottom link */}
        <p className="text-center text-[13px] text-secondary">
          Already have an account?{" "}
          <button
            type="button"
            onClick={() => console.log("[workshop] Navigate to login")}
            className="font-semibold text-accent hover:underline"
            data-testid="login-link"
          >
            Sign in
          </button>
        </p>
      </div>
    </AuthPageLayout>
  );
}
